<mat-card class="bo9mat">

  <main class="panel-viewport">
  @switch (currentPane) {

@case ('center') {
  <div>
      <mat-card class="bo9mat">
        <!--
        <span *ngIf="customers" >{{ customers.length }} Customers loaded.</span>
        <form novalidate >
          <label>Build select from customers containing this string: </label>
          <input type="text" [(ngModel)]="searchString" name="searchString"/>
          <button mat-flat-button color="primary" name="search" (click)="onClickSearch()">Search and Build Select List</button>
        </form>  -->
        <form novalidate >
          <label>Build select from order billing email that contains this string: </label>
          <input type="text" [(ngModel)]="searchString" name="searchString"/>
          <button mat-flat-button color="primary" name="searchb" (click)="onClickSearchBilling()">Search and Build Select List</button>
        </form>
      </mat-card>
      @let customers = customers$ | async;
      @if (customers) {
        <span><order-list [customers]="customers" ></order-list> </span>
      }
    </div>

    <div rightPane>


    </div>
    }
  }
</main>



</mat-card>
